export const SIDEBAR_WIDTH = {
  default: 260,
  desktopAndSmaller: 260,
  laptopAndSmaller: 111,
}
